import { GetterTree } from 'vuex';
import { LiveState } from './types';
import { RootState } from '../types';

const getters: GetterTree<LiveState, RootState> = {
  isSpeaking(state): boolean {
    return !!state.speaker.account && state.allowSpeak;
  },

  isMeSpeaking(state): boolean {
    return !!state.speaker.account && state.speaker.account === state.mine.account;
  },
};

export default getters;
